module.exports = __webpack_public_path__ + "static/media/clock-circular-outline.b40d9776.svg";